import { ApiResponse } from "../models/api-response";
import { InterestedUser } from "../models/interested-user";
import { LoginMethod } from "../models/login-methods";
import { OtpMethod } from "../models/otp-methods";
import { OTPValidationResponse } from "../models/otp-validation-response";
import { PluginConfig } from "../models/plugin-config";
import { getISO3LangCode } from "../utils/helpers";

export async function sendOTP(
    config: PluginConfig | null,
    otpMethod: OtpMethod,
    loginMethod: LoginMethod,
    loginData: string = "",
    bookingDomain: string | undefined
): Promise<ApiResponse<string>> {
    const url = `${bookingDomain}api/club/one-time-password?chainId=${config?.chainId}&lang=${getISO3LangCode(config?.language)}&type=${otpMethod}`

    const response = await fetch(url,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                [loginMethod]: loginData
            }),
            credentials: 'include'
        }
    );
    if (!response.ok) throw new Error('Failed to send OTP');
    return response.json();
}

export async function validateOTP(
    config: PluginConfig | null,
    token: string = "",
    otpMethod: OtpMethod,
    bookingDomain: string | undefined,
    guestId: number | null = null
): Promise<ApiResponse<OTPValidationResponse | InterestedUser>> {
    const url = `${bookingDomain}api/club/validate-one-time-token?chainId=${config?.chainId}&lang=${getISO3LangCode(config?.language)}&type=${otpMethod}`

    const response = await fetch(url,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token,
                interestedUser: guestId ?? undefined
            }),
            credentials: 'include'
        }
    );
    if (!response.ok) throw new Error('Failed to validate OTP');
    return response.json();
}

export async function logout(
    config: PluginConfig | null,
    otpMethod: OtpMethod,
    bookingDomain: string | undefined
): Promise<ApiResponse<boolean>> {
    const url = `${bookingDomain}api/session/external-logout?chainId=${config?.chainId}&lang=${getISO3LangCode(config?.language)}&type=${otpMethod}`

    const response = await fetch(url, { credentials: 'include' });

    if (!response.ok) throw new Error('Failed to logout');
    return response.json();
}

export async function recoverProfile(
    config: PluginConfig | null,
    loginData: string = "",
    bookingDomain: string | undefined
): Promise<ApiResponse<string>> {
    const url = `${bookingDomain}api/club/send-activation-link-email/?lang=${getISO3LangCode(config?.language)}&chainId=${config?.chainId}`

    const response = await fetch(url,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "mail": loginData
            }),
            credentials: 'include'
        }
    );
    if (!response.ok) throw new Error('Send activation link failed');
    return response.json();
}